import { type components } from '@libraries/typescript/api_client';

export type OutreachStatus = components['schemas']['OutreachStatusRead'];
export type OutreachCardStatus = OutreachStatus | 'unavailable';
export type OutreachCardHeading = 'created' | 'existing';

export const OUTREACH_CARD_HEADINGS: Record<OutreachCardHeading, string> = {
    created: 'Outreach created',
    existing: 'Outreach',
};

export const OUTREACH_CARD_STATES: Record<
    OutreachCardStatus,
    Readonly<{
        label: string;
        terminal: boolean;
        indicator: 'pulse' | 'check' | 'pause' | 'cancel' | 'none';
    }>
> = {
    pending: { label: 'Preparing', terminal: false, indicator: 'none' },
    in_progress: { label: 'Running', terminal: false, indicator: 'pulse' },
    paused: { label: 'Paused', terminal: false, indicator: 'pause' },
    filled: { label: 'Finished', terminal: true, indicator: 'check' },
    unfilled: { label: 'Finished', terminal: true, indicator: 'check' },
    cancelled: { label: 'Cancelled', terminal: true, indicator: 'cancel' },
    unavailable: {
        label: 'Status unavailable',
        terminal: false,
        indicator: 'none',
    },
};
